module.exports = __webpack_public_path__ + "media/images/ic_animaux-726efb3a69e4ea7aa0115bc4e11df470.svg";